export enum UsersEnum {
  MANAGER = "MANAGER",
  WEBMASTER = "WEBMASTER",
  ADVERTISER = "ADVERTISER"
}